import PropTypes from 'prop-types';
import React from 'react';

export default class CustomEvent extends React.Component {
  render() {
    return <div>{this.props.event.type}</div>;
  }
}

CustomEvent.propTypes = {
  event: PropTypes.object.isRequired,
  slotStart: PropTypes.instanceOf(Date),
  slotEnd: PropTypes.instanceOf(Date),

  selected: PropTypes.bool,
  isAllDay: PropTypes.bool,
  continuesPrior: PropTypes.bool,
  continuesAfter: PropTypes.bool,

  accessors: PropTypes.object,
  components: PropTypes.object,
  getters: PropTypes.object,
  localizer: PropTypes.object,

  onSelect: PropTypes.func,
  onDoubleClick: PropTypes.func,
};
